
import { Component, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';

import { Subscription, filter } from 'rxjs';

import { WireRegion } from '../../../../api/wire/enums/wire-region.enum';
import { WireQuotaApiModel } from '../../../../api/wire/models/wire-quota-api.model';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { WireService } from '../../services/wire.service';


@Component({
    selector: 'agpr-wire-region-select',
    templateUrl: './wire-region-select.component.html',
    styleUrls: ['./wire-region-select.component.scss'],
    standalone: false
})
export class WireRegionSelectComponent implements OnInit, OnDestroy {
    readonly wireRegionEnum = WireRegion;
    readonly messageSeverities = messageSeverityEnum;

    @Output() wireRegionChange = new EventEmitter<WireRegion>();

    selectedRegion: WireRegion;

    quotas: WireQuotaApiModel[] = [];
    subscriptions: Subscription[] = [];
    showQuotaWarning: boolean = false;

    constructor(
        private wireService: WireService
    ) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.wireService.quotas$.pipe(filter(x => !!x)).subscribe(wireQuotas => {
                this.quotas = wireQuotas.filter(wireQuota =>
                    // baselineWires > 0 or additionalWires > 0 means user has that region provision
                    (!!wireQuota.baselineWires || !!wireQuota.additionalWires)
                    // currently only support united_states and united_kingdom
                    && (wireQuota.region === WireRegion.united_states || wireQuota.region === WireRegion.united_kingdom )
                );

                if (this.quotas?.length > 0) {
                    // by default, select the first region in quotas
                    this.selectedRegion = this.quotas[0].region;
                    this.updateShowQuotaWarning();
                } else {
                    // if no quota, select other as default
                    this.selectedRegion = WireRegion.other;
                }
                this.onRegionSelect(this.selectedRegion);
            }),
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    onRegionSelect(region: WireRegion) {
        if (region !== WireRegion.other) {
            this.updateShowQuotaWarning();
        }
        this.wireRegionChange.emit(region);
    }

    updateShowQuotaWarning(): void {
        this.showQuotaWarning = !this.wireService.isQuotaSufficient(this.selectedRegion, this.quotas);
    }
}
